const DOTTED_LINE_PREVIEW_CY = 1;
const DOTTED_LINE_PREVIEW_RADIUS = 1;
const DOT_SPACING = 5;

export { DOTTED_LINE_PREVIEW_CY, DOTTED_LINE_PREVIEW_RADIUS, DOT_SPACING };
